import { ServiceInfo } from "@/business/ComponentViews/ServiceInfo";

export class ServiceStore {

  public static getDataSet( store: any) : ServiceInfo {    
    return store.getters["servicestore/setDataSet"];
  
  }

  public static setDataSet( store: any, payload: ServiceInfo) {
    store.commit("servicestore/getDataSet" , payload)
  }

}

export const servicestore = {
  namespaced: true,
  state: {
    serviceInfo: {
      services: [],
    }
  },
  mutations: {
    setDataSet(state: any, payload: ServiceInfo) {
      state.serviceInfo = payload;
    }
  },
  actions: {},
  getters: {
    getDataSet: function(state: any): ServiceInfo {
      return state.serviceInfo;
    }
  }
};
